module.exports = __webpack_public_path__ + "static/media/Beautifly_gaussian2.505103da.png";